import React, { FC } from 'react';
import idGenerator from 'react-id-generator';
import { RadioInput, RadioWrapper } from './RadioField.style';

type RadioFieldProps = {
  value: string;
  onChange?: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  isDisabled?: boolean;
  isChecked?: boolean;
  children?: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  error?: string | boolean;
};

export const RadioField: FC<RadioFieldProps> = ({
  value = '',
  isDisabled = false,
  isChecked = false,
  children = null,
  onChange,
  error,
}) => {
  const handleCheck = (e: any) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  const id = `${idGenerator()}-radio`;

  return (
    <RadioWrapper>
      <RadioInput
        id={id}
        aria-checked={isChecked}
        type="radio"
        value={value}
        onChange={handleCheck}
        disabled={isDisabled}
        checked={isChecked}
        error={error}
      />
      <label htmlFor={id}>{children}</label>
    </RadioWrapper>
  );
};
